'use client';

import React from "react";
import PropTypes from 'prop-types';

MapMarker.propTypes = {
    type: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default function MapMarker({
    type,
    className
}) {
    return (
        <img
            className={`map-marker ${className}`}
            src={`/wp-content/themes/bedrock-theme/static/images/map-${type}.svg`}
            alt=""
            width={28}
            height={33}
        />
    )
}